const moment = require('moment-timezone')
const { getTimezoneByAgencyId } = require('./agency-timezones')

function parseAgencyDateInput (dateValue, agencyId) {
  if (dateValue === null || dateValue === undefined || dateValue === '') {
    return null
  }

  const timezone = getTimezoneByAgencyId(agencyId)
  const asString = String(dateValue).trim()
  const dateOnlyMatch = /^(\d{4}-\d{2}-\d{2})/.exec(asString)

  if (dateOnlyMatch) {
    const parsed = moment.tz(dateOnlyMatch[1], 'YYYY-MM-DD', true, timezone)
    return parsed.isValid() ? parsed : null
  }

  const parsed = moment.tz(asString, timezone)
  return parsed.isValid() ? parsed : null
}

function toAgencyDayStartIso (dateValue, agencyId) {
  const parsed = parseAgencyDateInput(dateValue, agencyId)
  return parsed ? parsed.clone().startOf('day').toISOString() : null
}

function toAgencyDayEndExclusiveIso (dateValue, agencyId) {
  const parsed = parseAgencyDateInput(dateValue, agencyId)
  return parsed ? parsed.clone().add(1, 'day').startOf('day').toISOString() : null
}

function formatAgencyDateInput (dateValue, agencyId) {
  const timezone = getTimezoneByAgencyId(agencyId)
  const parsed = moment(dateValue).tz(timezone)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null
}

function formatAgencyPeriodEndDateInput (dateValue, agencyId) {
  const timezone = getTimezoneByAgencyId(agencyId)
  const parsed = moment(dateValue).tz(timezone)

  if (!parsed.isValid()) {
    return null
  }

  if (parsed.format('HH:mm:ss.SSS') === '00:00:00.000') {
    return parsed.clone().subtract(1, 'day').format('YYYY-MM-DD')
  }

  return parsed.format('YYYY-MM-DD')
}

function getAgencyLocalDateParts (dateValue, agencyId) {
  const timezone = getTimezoneByAgencyId(agencyId)
  const parsed = moment(dateValue).tz(timezone)

  if (!parsed.isValid()) {
    return null
  }

  return {
    dayOfWeek: parsed.day(),
    dayOfMonth: parsed.date(),
    month: parsed.month() + 1
  }
}

function normalizeOncePeriodBounds ({ periodStart, periodEnd, agencyId }) {
  if (!agencyId) {
    return {
      periodStart: periodStart,
      periodEnd: periodEnd
    }
  }

  const normalized = {
    periodStart: periodStart,
    periodEnd: periodEnd
  }

  if (periodStart) {
    const startDateInput = formatAgencyDateInput(periodStart, agencyId)
    normalized.periodStart = startDateInput
      ? toAgencyDayStartIso(startDateInput, agencyId)
      : periodStart
  }

  if (periodEnd) {
    const endDateInput = formatAgencyDateInput(periodEnd, agencyId)
    normalized.periodEnd = endDateInput
      ? toAgencyDayEndExclusiveIso(endDateInput, agencyId)
      : periodEnd
  }

  return normalized
}

module.exports = {
  parseAgencyDateInput,
  toAgencyDayStartIso,
  toAgencyDayEndExclusiveIso,
  formatAgencyDateInput,
  formatAgencyPeriodEndDateInput,
  getAgencyLocalDateParts,
  normalizeOncePeriodBounds
}
